import {
  type ResourceType,
  ConditionOperatorEnum,
  type Provider,
} from '@repo/api-gw-sdk';
import { useMemo } from 'react';

import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';

import {
  cloudProvider,
  resourceId,
  resourceName,
  resourceType,
} from './properties';

export const useResourceIdentifiers = (
  providers?: Provider[],
  resourceTypes?: ResourceType[],
  nameFilter?: string
) => {
  const dal = useDAL();
  const condition = useMemo(() => {
    const providersCondition = providers?.length
      ? [
          {
            property: cloudProvider.name,
            operator: ConditionOperatorEnum.In,
            value: providers,
          },
        ]
      : [];
    const resourceTypeCondition = resourceTypes?.length
      ? [
          {
            property: resourceType.name,
            operator: ConditionOperatorEnum.In,
            value: resourceTypes,
          },
        ]
      : [];
    const identifierCondition = nameFilter
      ? [
          createCombineCondition(
            [
              {
                property: resourceName.name,
                operator: ConditionOperatorEnum.Contains,
                value: [nameFilter],
              },
              {
                property: resourceId.name,
                operator: ConditionOperatorEnum.Contains,
                value: [nameFilter],
              },
            ],
            ConditionOperatorEnum.Or
          ),
        ]
      : [];
    const conditions = [
      ...providersCondition,
      ...resourceTypeCondition,
      ...identifierCondition,
    ];
    if (conditions.length === 0) {
      return undefined;
    }
    return createCombineCondition(conditions);
  }, [providers, resourceTypes, nameFilter]);
  return dal.inventory.useListResourceIdentifiers(condition);
};
